<form>
    <div class="option-box">
        <div class="form-group mb-2">
            <label for="formSelectAfficher">{{ 'pageOrganization.displaying' | translate }}</label>
            <select class="form-control" name="formSelectAfficher" id="formSelectAfficher" (change)="onChangeAffichage($event)">
                <option *ngFor="let n of afficherPerPage" [value]="n" [selected]="n === affichageSelected">{{ n }} par page</option>
            </select>
        </div>
        <div class="form-group mb-2">
            <label for="formSelect">{{ 'pageOrganization.sortBy' | translate }}</label>
            <select class="form-control" name="formSelect" id="formSelect" (change)="onChangeTrierPar($event)">
                <option *ngFor="let option of trierParOptions" [value]="option" [selected]="option === optionSelected">{{ option }}</option>
            </select>
        </div>
    </div>
</form>
